import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { ThumbnailImage } from '.';
import { thumbnailImageDriverFactory } from './ThumbnailImage.driver';

describe('ThumbnailImage', () => {
  const createDriver = createRendererWithUniDriver(thumbnailImageDriverFactory);

  const sampleSource = 'c5f754_f4ccb2e3ed75479dbfd55e02ef9c47e8~mv2.png';
  const sampleDimensions = { width: 300, height: 300 };

  it('should render', async () => {
    const { driver } = createDriver(
      <ThumbnailImage src={sampleSource} {...sampleDimensions} />,
    );

    expect(await driver.exists()).toBe(true);
  });
});
